import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Chapters from "@/components/landing/Chapters";
import Steps from "@/components/landing/Steps";
import Pricing from "@/components/landing/Pricing";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="relative min-h-screen bg-[#FAFBFD] text-slate-900" data-testid="landing-page">
            <div className="grain-overlay" />
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Chapters />
                <Steps />
                <Pricing />
                <Faq />
            </main>
            <Footer />
        </div>
    );
}
